import { render, staticRenderFns } from "./ValueChainPropertiesAttribute.vue?vue&type=template&id=6c886cd0&scoped=true&"
import script from "./ValueChainPropertiesAttribute.vue?vue&type=script&lang=js&"
export * from "./ValueChainPropertiesAttribute.vue?vue&type=script&lang=js&"
import style0 from "./ValueChainPropertiesAttribute.vue?vue&type=style&index=0&id=6c886cd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c886cd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
